import Gallery from '../../Gallery';
import SectionHeadingStyle2 from '../../SectionHeading/SectionHeadingStyle2';

export default function PortfolioSectionStyle2({data,sectionTitle,sectionSubTitle,sectionTitleUp, hideFilter = false, textVarient, variableWidths = false, initialShowCount = 6, layoutPatternRows}) {
  return (
    <div className="container">
      <SectionHeadingStyle2 sectionTitleUp={sectionTitleUp} sectionTitle={sectionTitle} sectionSubTitle={sectionSubTitle} textVarient={textVarient} className='cs_mb_60 cs_mb_lg_40' />
      <Gallery data={data} hideFilter={hideFilter} variableWidths={variableWidths} initialShowCount={initialShowCount} layoutPatternRows={layoutPatternRows}/>
    </div>
  )
}
